import {  Inject, Component, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterLink, ActivatedRoute, ParamMap }          from '@angular/router';
import {MellonService} from "../../account/mellon.service";
import { Observable }           from 'rxjs';
import { map }                  from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';
import { Location, isPlatformBrowser } from '@angular/common';

import { Angulartics2 } from 'angulartics2';


declare var $;


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  constructor(private router: Router, private mellonService: MellonService, private route: ActivatedRoute, private angulartics2: Angulartics2, @Inject(PLATFORM_ID) private platform: any) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platform)) {
        if (this.router.url == '/logout') {
          //Trigger Mellon Logout
          this.mellonService.triggerLink('getAccountLogout');
        }
      if (this.router.url == '/logouta3ta4h') {
        //Trigger Mellon Logout
         this.mellonService.triggerLink('getAccountLogout');
      }
        if (this.route.snapshot.routeConfig.path == 'login') {
            this.mellonService.triggerLink('getLogin');
        }

        if (this.route.snapshot.routeConfig.path == 'activate') {
            let code = this.route.snapshot.paramMap.get('code');
            this.mellonService.triggerLink('getActivation', code);
        }
        if (this.route.snapshot.routeConfig.path == 'password-reset') {
            let code = this.route.snapshot.paramMap.get('code');
            this.mellonService.triggerLink('getAuthenticationPasswordReset', code);
        }
        if (this.route.snapshot.routeConfig.path == 'unban') {
            let code = this.route.snapshot.paramMap.get('code');
            this.mellonService.triggerLink('getUnbanAndLogin', code);
        }
        if (this.route.snapshot.routeConfig.path == 'unban-reset') {
            let code = this.route.snapshot.paramMap.get('code');
            let token = this.route.snapshot.paramMap.get('token');
            this.mellonService.triggerLink('getAuthenticationUnbanAndPasswordReset', code, token);
        }
        if (this.route.snapshot.routeConfig.path == 'register' || this.route.snapshot.routeConfig.path == 'register/:betaKey' || this.route.snapshot.routeConfig.path == 'register/:betaKey/:userParam' || this.route.snapshot.routeConfig.path == 'register/:betaKey/:userParam/:referral' ) {
            let userParam = this.route.snapshot.paramMap.get('userParam');
            let betaCode = this.route.snapshot.paramMap.get('betaKey');
            let referral = this.route.snapshot.paramMap.get('referral');
            if(referral != '') {
              referral = '/referral/'+referral;
            }
            this.mellonService.triggerLink('getRegistration', userParam, betaCode, null, referral);
        }
        if (this.route.snapshot.routeConfig.path == 'acceptInvite' || this.route.snapshot.routeConfig.path == 'acceptInvite/:referral'  ) {
          let referral = this.route.snapshot.paramMap.get('referral');
          if(referral != '') {
            referral = '/referral/'+referral;
          }
          this.mellonService.triggerLink('getRegistration', null, null, null, referral);
        }
        $(window).on('activate.bs.scrollspy', (e, obj) => {
          this.router.navigate(this.route.snapshot.url, {fragment: obj.relatedTarget.replace('#', '')});
          //this.angulartics2.pageTrack.next();
        })
    }
  }

}
